
export const approverHistoryColumnDefs = [
 
  {
    headerName: 'Material Plant',
    field: 'materialPlant',

  },
  {
    headerName: 'IO Material Type',
    field: 'ioMaterialType',
   
  },
  {
    headerName: 'Planning Lead',
    field: 'planningLead',
    
  },
  {
    headerName: 'Approver Name',
    field: 'approverName',
    
  },
  {
    headerName: 'Approver Email',
    field: 'approverEmail',
   
  },
  {
    headerName: 'From',
    field: 'fromDate',
    
  },
  {headerName :'TO',
    field :'toDate'
  }
];